import React, { useState, useEffect, useContext } from "react";
import useWindowDimensions from "../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import { colors } from "../../themes/Colors";
import { MenuLayout } from "./components/agency-admin-components";
import {
  IconOnlyButton,
  LoadingPopUp,
  ToastNotification,
} from "../common-components";
import {
  AgencyProfileDisplay,
  AgentsDisplay,
  BuzzDisplay,
  Catalogue,
  TasksDisplay,
  UserDisplay,
  Vehicles,
} from "./components";
import { AuthContext } from "../../context/auth-context";
import { useNavigate } from "react-router-dom";

const AgencyAdmin = () => {
  const { width, height } = useWindowDimensions();
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [toastPop, setToastPop] = useState(false);
  const [popUpTitle, setPopUpTitle] = useState(false);

  const [screenDisplay, setScreenDisplay] = useState("tasks");
  const [customerButton, setCustomerButton] = useState(false);
  const [customerArray, setCustomerArray] = useState([]);
  const [AgentButton, setAgentButton] = useState(false);
  const [agentsArray, setAgentsArray] = useState([]);
  const [buzzButton, setBuzzButton] = useState(false);
  const [buzzArray, setBuzzArray] = useState([]);

  const [companyInformation, setCompanyInformation] = useState(null);

  const [refresh, setRefresh] = useState(false);

  const getCompanyInformation = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/agency/getAgencyCompanyInfo",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth.customerUserData.userId,
            companyId: auth.customerUserData.companyId,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setCompanyInformation(respnseData.companyInfo);

        // setToastPop(true);
        // setPopUpTitle("SUCCESS");
        // setMessage("Log-in successful");
        setLoading(false);

        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage("Unable to Login because, " + " " + respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      setLoading(false);
      setMessage(
        "Unable to login into account, please wait 5 mins then try again or contact support" +
          " " +
          err
      );
      setToastPop(true);
      console.log("error", err);
    }
  };
  console.log("companyInformation", companyInformation);

  const [adminAccess, setAdminAccess] = useState(false);

  useEffect(() => {
    if (!auth.isloggedIn || auth.customerUserData.type === "Customer") {
      // console.log("path check", admin.adminUserData.type);

      navigate("/agency");
    } else if (
      auth.customerUserData.type === "ADMIN" ||
      auth.customerUserData.type === "TEAM LEADER"
    ) {
      setCustomerButton(true);
      setAgentButton(true);
      setBuzzButton(true);
      setAdminAccess(true);
    }
  }, []);

  useEffect(() => {
    if (toastPop) {
      setTimeout(() => {
        setToastPop(false);

        setTimeout(() => {
          setPopUpTitle("");
          setMessage("");
        }, 3000);
      }, 5000);
    }
  }, [toastPop]);
  useEffect(() => {
    if (companyInformation) {
      if (companyInformation.accountStatus === "PENDING APPROVAL") {
        setScreenDisplay("profile");
      } else if (
        companyInformation.type === "business" &&
        companyInformation.accountStatus === "PENDING APPROVAL"
      ) {
        setScreenDisplay("profile");
      } else if (
        companyInformation.type === "business" &&
        companyInformation.accountStatus === "APPROVED"
      ) {
        setScreenDisplay("users");
      }
    }
  }, [companyInformation]);
  useEffect(() => {
    if (auth) {
      getCompanyInformation();
    }
  }, [refresh]);
  return (
    <div
      style={{
        height: height,
        width: width,
        // backgroundColor: "#489FB5",
        backgroundColor: companyInformation
          ? companyInformation.type === "business"
            ? colors.primaryOrange
            : colors.primaryBlue
          : colors.primaryBlue,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <MenuLayout
        selected={screenDisplay}
        businessType={companyInformation ? companyInformation.type : null}
        onUserClick={() => setScreenDisplay("users")}
        onAgentsClick={() => setScreenDisplay("agents")}
        onProfileClick={() => setScreenDisplay("profile")}
        onTaskClick={() => setScreenDisplay("tasks")}
        onBuzzClick={() => setScreenDisplay("buzz")}
        customerButton={customerButton}
        AgentButton={AgentButton}
        buzzButton={buzzButton}
        adminAccess={adminAccess}
        onCatalogueClick={() => setScreenDisplay("catalogue")}
        onVehiclesClick={() => setScreenDisplay("vehicles")}
        accountStatus={
          companyInformation
            ? companyInformation.accountStatus === "PENDING APPROVAL"
              ? true
              : false
            : false
        }
      />
      <div
        style={{
          flex: 1,
          height: "100%",
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            height: 65,

            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <div style={{ zIndex: 100, marginRight: 20 }}>
            <div
              style={{
                height: 40,
                width: 180,
                backgroundColor: colors.secondaryGrey,
                borderRadius: 10,
                borderStyle: "solid",
                borderWidth: 3,
                borderColor: colors.white,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: 10,
                  marginTop: 5,
                  marginBottom: 2,
                }}
              >
                ACCOUNT STATUS
              </div>
              <div
                style={{
                  fontSize: 14,
                }}
              >
                {companyInformation
                  ? companyInformation.accountStatus
                  : "loading"}
              </div>
            </div>
          </div>
          <div style={{ color: colors.white, fontWeight: "bold" }}>
            {auth
              ? (
                  auth.customerUserData.firstName +
                  " " +
                  auth.customerUserData.lastName
                ).toLocaleUpperCase()
              : "loading"}
          </div>
          <div style={{ minWidth: 20 }} />
          <IconOnlyButton
            onClick={null}
            iconImage={require("../../images/icons/pofileWhite.png")}
            height={40}
            width={40}
          />
          <div style={{ minWidth: 10 }} />
        </div>
        <div
          style={{
            flex: 1,
            // borderStyle: "solid",
            // height: "100%",
            position: "relative",
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}
        >
          <div
            style={{
              height: "100%",
              // maxHeight: 900,
              // minHeight: 450,
              width: "100%",
              // minWidth: 500,
              // maxWidth: 1500,
              backgroundColor: colors.secondaryGrey,
              // marginTop: 15,
              // borderRadius: 20,
              // marginLeft: 35,
              WebkitBoxShadow: "-2px 20px 40px -10px #000000",
              // borderStyle: "solid",
              // borderWidth: 4,
              // borderColor: colors.white,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              position: "relative",
            }}
          >
            {screenDisplay === "users" ? (
              <UserDisplay
                auth={auth.customerUserData}
                companyInformation={companyInformation}
                setLoading={setLoading}
                setMessage={setMessage}
                setToastPop={setToastPop}
                setPopUpTitle={setPopUpTitle}
              />
            ) : null}
            {screenDisplay === "agents" ? (
              <AgentsDisplay
                auth={auth.customerUserData}
                companyInformation={companyInformation}
                setLoading={setLoading}
                setMessage={setMessage}
                setToastPop={setToastPop}
                setPopUpTitle={setPopUpTitle}
              />
            ) : null}
            {screenDisplay === "tasks" ? (
              <TasksDisplay
                auth={auth.customerUserData}
                companyInformation={companyInformation}
                setLoading={setLoading}
                setMessage={setMessage}
                setToastPop={setToastPop}
                setPopUpTitle={setPopUpTitle}
              />
            ) : null}
            {screenDisplay === "profile" ? (
              <AgencyProfileDisplay
                auth={auth.customerUserData}
                companyInformation={companyInformation}
                setLoading={setLoading}
                setMessage={setMessage}
                setToastPop={setToastPop}
                setPopUpTitle={setPopUpTitle}
                setRefresh={setRefresh}
                refresh={refresh}
              />
            ) : null}

            {screenDisplay === "buzz" ? (
              <BuzzDisplay
                auth={auth.customerUserData}
                companyInformation={companyInformation}
                setLoading={setLoading}
                setMessage={setMessage}
                setToastPop={setToastPop}
                setPopUpTitle={setPopUpTitle}
                setRefresh={setRefresh}
                refresh={refresh}
              />
            ) : null}
            {screenDisplay === "vehicles" ? (
              <Vehicles
                auth={auth.customerUserData}
                companyInformation={companyInformation}
                setLoading={setLoading}
                setMessage={setMessage}
                setToastPop={setToastPop}
                setPopUpTitle={setPopUpTitle}
                setRefresh={setRefresh}
                refresh={refresh}
              />
            ) : null}
            {screenDisplay === "catalogue" ? (
              <Catalogue
                auth={auth.customerUserData}
                companyInformation={companyInformation}
                setLoading={setLoading}
                setMessage={setMessage}
                setToastPop={setToastPop}
                setPopUpTitle={setPopUpTitle}
                setRefresh={setRefresh}
                refresh={refresh}
              />
            ) : null}
          </div>
        </div>
      </div>
      <LoadingPopUp display={loading} />
      <ToastNotification
        display={toastPop}
        title={popUpTitle}
        mainTitle={popUpTitle}
        message={message}
        width={width}
      />
    </div>
  );
};

export default AgencyAdmin;
